import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

/**
 * Commponent for empty state
 */
@Component({
  selector: '[app-empty-state]',
  templateUrl: './empty-state.component.html',
})
export class EmptyStateComponent implements OnDestroy {
  @Input() public emptyStateIcon: string;
  @Input() public emptyStateText: string;
  @Input() public emptyStateButtonText: string = null;

  @Output() public actionButtonClickEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  public ngOnDestroy(): void { }

  /**
   * This event fires after the button was clicked
   */
  public actionButtonClick(): void {
    this.actionButtonClickEvent.emit('click');
  }

}
